import { apiClient } from 'api'
import { RoleToUser } from 'types/roles'

type NewItem = Omit<RoleToUser, 'role'>

export const addRoleToUser = (userId: number, roleId: number) =>
    apiClient.post<NewItem>('/roles-to-users', {
        userId,
        roleId,
    })

export const deleteRoleToUser = (userId: number, roleId: number) =>
    apiClient.delete(`/roles-to-users/${userId}/${roleId}`)

export const getRolesToUser = (userId: number) => apiClient.get<RoleToUser[]>(`/roles-to-users/${userId}`)
